import { createSelector } from 'reselect';

// Config
import {
  getIsDeliveryPageInitialisedSelector,
  getShowCollectionHelpSelector,
  getShowPersonalisationMessageSelector,
  getConfirmedDeliveryAddressSelector,
  getDeliveriesSelector,
  getDeliveryOptionsSelector,
  getDeliveryPageApiCallCompleteSelector,
  getPutDeliveryAddressApiCallActiveSelector,
  getSelectedDeliveryChoiceIdSelector,
  getShowClickCollectNowAvailableMessageSelector,
  getUndeliverableItemsInBasketSelector,
  getShowEditBasketModalSelector,
} from '@redux/reducers/delivery/deliverySelector';
import { getOrderFormItemsSelector } from '@redux/reducers/order-form/orderFormSelector';
import {
  getIsPartnerDiscountProcessingSelector,
  getEligibleForPartnerDiscountSelector,
  getUserIsGuestSelector,
  getUserIsMyJLMemberSelector,
  getPartnerDiscountStatusSelector,
  getSelectedDeliveryAddressSelector,
} from '@redux/reducers/user/userSelector';
import { getDeliveryMessageFeatureSelector } from '@redux/reducers/config/configSelector';

export const showLoadingSpinner = createSelector(
  [
    getDeliveryPageApiCallCompleteSelector,
    getSelectedDeliveryAddressSelector,
    getPutDeliveryAddressApiCallActiveSelector,
  ],
  (getDeliveryPageApiCallComplete, selectedDeliveryAddress, putDeliveryAddressApiCallActive) => {
    return !!(
      !getDeliveryPageApiCallComplete ||
      (selectedDeliveryAddress && !selectedDeliveryAddress.invalid && putDeliveryAddressApiCallActive)
    );
  },
);

export const showBatchedDeliveries = createSelector(
  [getUndeliverableItemsInBasketSelector, getDeliveryPageApiCallCompleteSelector, getConfirmedDeliveryAddressSelector],
  (undeliverableItemsInBasket, getDeliveryPageApiCallComplete, confirmedDeliveryAddress) => {
    return !!(getDeliveryPageApiCallComplete && confirmedDeliveryAddress && undeliverableItemsInBasket?.length === 0);
  },
);

const deliveryState = createSelector(
  [
    getIsDeliveryPageInitialisedSelector,
    getShowCollectionHelpSelector,
    getShowPersonalisationMessageSelector,
    getDeliveriesSelector,
    getDeliveryOptionsSelector,
    getIsPartnerDiscountProcessingSelector,
    getEligibleForPartnerDiscountSelector,
    getUserIsGuestSelector,
    getUserIsMyJLMemberSelector,
    getOrderFormItemsSelector,
    getPartnerDiscountStatusSelector,
    getSelectedDeliveryChoiceIdSelector,
    getShowClickCollectNowAvailableMessageSelector,
    showLoadingSpinner,
    showBatchedDeliveries,
    getShowEditBasketModalSelector,
    getDeliveryMessageFeatureSelector,
  ],
  (
    isDeliveryPageInitialised,
    showCollectionHelp,
    showPersonalisationMessage,
    deliveries,
    deliveryOptions,
    isPartnerDiscountProcessing,
    eligibleForPartnerDiscount,
    isGuest,
    isMyJLMember,
    items,
    partnerDiscountStatus,
    selectedDeliveryChoiceId,
    showClickCollectNowAvailableMessage,
    showLoadingSpinner,
    showBatchedDeliveries,
    showEditBasketModal,
    deliveryMessageFeature,
  ) => ({
    isDeliveryPageInitialised,
    showCollectionHelp,
    showPersonalisationMessage,
    deliveries,
    deliveryOptions,
    isPartnerDiscountProcessing,
    eligibleForPartnerDiscount,
    isGuest,
    isMyJLMember,
    items,
    partnerDiscountStatus,
    selectedDeliveryChoiceId,
    showClickCollectNowAvailableMessage,
    showLoadingSpinner,
    showBatchedDeliveries,
    showEditBasketModal,
    deliveryMessageFeature,
  }),
);

export default deliveryState;
